export const announcementConstants = {
  GET_ALL_REQUEST: "ANNOUNCEMENT_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "ANNOUNCEMENT_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "ANNOUNCEMENT_GET_ALL_FAILURE",
};
